export default [
    'updateOrigin',
    'updateDestination',
    'updateArriveDate',
    'updateArriveTime',
    'updateArriveDateAndTime',
    'updateRailcardType',
    'updateHasAccessToCar',
    'updateHasConcessionaryPass',
    'updateJourneySorting',
    'updateJourneyFilter',
    'updateJourneyResults',
    'updateJourneyType',
    'updateJourneyTypeFilter',
    'updateReturnDate',
    'updateVia',
    'updateCurrentLocation',
    'setResults',
    'addToResults',
    'clearResults',
    'setLoading',
    'setError',
    'setSearchQueryResults',
    'setCurrentJourney',
    'updateArriveTimeHour',
    'updateArriveTimeMinutes',
    'campaigns',
    'campaignImpressions',
]
